import { render, staticRenderFns } from "./LandingBlog.vue?vue&type=template&id=3fd230d6&scoped=true"
import script from "./LandingBlog.vue?vue&type=script&lang=js"
export * from "./LandingBlog.vue?vue&type=script&lang=js"
import style0 from "./LandingBlog.vue?vue&type=style&index=0&id=3fd230d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd230d6",
  null
  
)

export default component.exports